<template>
  <div>
    <hero-bar>
      Allocate Loads
    </hero-bar>
    <section class="section is-main-section">
      <card-component title="" icon="ballot">
        <b-table
          :data="jobs"
          :columns="columns"
          :paginated="isPaginated"
          :per-page="perPage"
          @click="selectJob"
        ></b-table>
      </card-component>
      <b-modal :active.sync="showLoadModal" :width="600" scroll="keep">
        <div class="card">
          <header class="modal-card-head">
            <p class="modal-card-title">Edit Load</p>
            <button type="button" class="delete" @click="closeModal()" />
          </header>
          <div class="card-content">
            <AllocateForm
              @saved="saveModal()"
              @cancelled="closeModal()"
              :edit="false"
            ></AllocateForm>
          </div>
        </div>
      </b-modal>
    </section>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import axios from "axios";
import AllocateForm from "@/components/AllocateForm";
import HeroBar from "@/components/HeroBar";
export default {
  name: "Forms",
  components: { HeroBar, CardComponent, AllocateForm },
  data() {
    return {
      jobs: [],
      addresses: [],
      isLoading: false,
      isHidden: false,
      isImageModalActive: false,
      showLoadModal: false,
      address: [],
      isPaginated: true,
      perPage: 10,
      form: {
        name: null,
        email: null,
        phone: null,
        status: "Booked",
        subject: null,
        notes: null,
        radio: null,
        requestedPickup: new Date()
      },
      statuses: ["Pending", "Booked", "Delivered", "Complete"],
      status: [
        { id: 1, name: "Pending" },
        { id: 2, name: "Booked" },
        { id: 3, name: "In Transit" },
        { id: 4, name: "Delivered" },
        { id: 5, name: "Completed" }
      ],
      columns: [
        { field: "sdate", label: "Scheduled", width: "100", searchable: true },
        { field: "load", label: "Load", width: "80", searchable: true },
        { field: "status", label: "Status", width: "40", searchable: true },
        { field: "client", label: "Charge To", width: "120", searchable: true },
        {
          field: "rdate",
          label: "Requested Pickup",
          width: "100",
          searchable: true
        },
        { field: "driver", label: "Driver", width: "60" },
        { field: "truck", label: "Truck", width: "60" },
        { field: "origin", label: "Pickup", width: "120" },
        { field: "dest", label: "Destination", width: "120" },
        { field: "id", label: "", visible: false },
        { field: "ssdate", label: "", visible: false }
      ]
    };
  },
  computed: {},
  methods: {
    submit() {},
    async getJobs() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport?mode=app&row_type=transport_booking&orderby=day",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        var i = 0;
        for (i = 0; i < data.length; i++) {
          var statusName = "";
          statusName = this.status.find(x => x.id === data[i].status).name;
          var requestDate = new Date(data[i].requestedPickupTime);
          const year = requestDate.getFullYear();
          const day = String(requestDate.getDate()).padStart(2, "0");
          const month = requestDate.getMonth();
          const hours = requestDate.getHours();
          const minutes = requestDate.getMinutes();
          var sdate = "";
          if (data[i].scheduledDate) {
            var scheduledDate = new Date(data[i].scheduledDate);
            const syear = scheduledDate.getFullYear();
            const sday = String(scheduledDate.getDate()).padStart(2, "0");
            const smonth = scheduledDate.getMonth() + 1;
            sdate = sday + "/" + smonth + "/" + syear;
          }

          this.jobs.push({
            ssdate: data[i].scheduledDate,
            sdate: sdate,
            rdate: day + "/" + month + "/" + year + " " + hours + ":" + minutes,
            client:
              data[i].accountCode +
              ":" +
              data[i].clientCode +
              " (" +
              data[i].clientCode +
              ")",
            load: data[i].loadName,
            driver: data[i].driverName,
            truck: data[i].truckName,
            origin:
              data[i].pickupAddress.address + " " + data[i].pickupAddress.town,
            dest:
              data[i].destinationAddress.address +
              " " +
              data[i].pickupAddress.town,
            status: statusName,
            id: data[i].bookingId
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    onChange() {
      this.isHidden = true;
    },
    selectJob(record) {
      if (!record.ssdate) {
        this.$store.commit("setScheduledDate", new Date());
      } else {
        this.$store.commit("setScheduledDate", record.ssdate);
      }
      this.$store.commit("setBookingId", Number(record.id));
      this.showLoadModal = true;
    },
    closeModal() {
      this.showLoadModal = false;
    },
    saveModal() {
      this.showLoadModal = false;
    },
    async getAddresses() {
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/address",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.addresses = data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.getAddresses();
    this.getJobs();
  }
};
</script>
